<script>
import GarageRow from "../GarageRow.vue";
import ClickOutside from "vue-click-outside";
import ActiveVehicle from "../ActiveVehicle.vue";
import Spinner from "../../Spinner.vue";
import AppointmentStore from "../../../mixins/appointment-store";

export default {
    name: "GarageOverview",

    components: {Spinner, ActiveVehicle, GarageRow},

    directives: {
        ClickOutside
    },

    mixins: [AppointmentStore],

    props: {
        garagesText: String
    },

    data() {
        return {
            place: null,
            gmapInputValue: '',

            autocompleteOptions: {
                types: ['geocode'],
                componentRestrictions: {
                    country: ['nl']
                }
            },

            loading: false,
        }
    },

    computed: {
        showResetButton() {
            return (!_.isEmpty(this.gmapInputValue) && !this.loading) || !_.isEmpty(this.geoPlace) && !this.loading;
        },
    },

    methods: {
        setPlace(place) {
            if (_.isEmpty(place.name)) {
                this.handleReset();
                return;
            }

            this.place = place;
            this.gmapInputValue = this.$refs.gmapAutocomplete.value;
            this.fetchData(true, false);
        },

        handleClickOutside() {
            this.inputFocused = false
        },

        handleFocus(payload) {
            this.inputFocused = true;
        },

        fetchData(fromPlace = false, fromGeo = false) {
            this.loading = true;
            let url = `/api/garages`;

            if (fromPlace) {
                url = url.concat(`?lat=${this.place.geometry.location.lat()}&lng=${this.place.geometry.location.lng()}`);
            }

            if (fromGeo) {
                url = url.concat(`?lat=${this.geoPlace.lat}&lng=${this.geoPlace.lng}`);
            }

            axios.get(url)
                .then(response => {
                    this.appointmentStore.garages = response.data;
                })
                .catch(error => {
                    this.appointmentStore.garages = [];
                })
                .finally(() => {
                    this.loading = false;
                });
        },

        geoLocate() {
            navigator.geolocation.getCurrentPosition(position => {
                if (_.isEmpty(this.activeMarker)) {
                    const coords = {
                        lat: position.coords.latitude,
                        lng: position.coords.longitude
                    };

                    this.geoPlace = coords;

                    this.geoCode(coords);
                    this.fetchData(false, true);
                }
            });
        },

        geoCode(coords) {
            const geocoder = new google.maps.Geocoder();

            geocoder.geocode({location: coords}, (results, status) => {
                if (status !== google.maps.GeocoderStatus.OK) {
                    return;
                }

                const locationString = results[0]?.formatted_address;

                if (_.isNil(locationString)) {
                    return;
                }

                this.gmapInputValue = locationString;
                this.$refs.gmapAutocomplete.value = locationString;
            })
        },

        handleReset() {
            this.place = null;
            this.gmapInputValue = '';
            this.$refs.gmapAutocomplete.value = '';
            this.geoPlace = {};
        },
    },

    created() {
        if (this.appointmentStore.hasInitialGarage) {
            this.appointmentStore.activeGarage = this.appointmentStore.initialGarage
        }

        this.fetchData()
    }
}
</script>

<template>
    <div class="vue-garage-overview">
        <template v-if="!appointmentStore.hasInitialGarage">
            <div class="intro-wrapper mb-5">
                <div v-html="garagesText"></div>
                <div class="carprof-finder-searchbar finder-search-input">
                    <div class="finder-input" @focusin="handleFocus">
                        <gmap-autocomplete
                            slotRefName="gmapAutocomplete"
                            :select-first-on-enter="true"
                            class="w-100"
                            @place_changed="setPlace"
                            :options="autocompleteOptions"
                            v-click-outside="() => handleClickOutside()"
                        >
                            <input ref="gmapAutocomplete" placeholder="Zoek op plaats of postcode"
                                   class="pac-target-input vue-gmap-autocomplete form-control">
                        </gmap-autocomplete>

                        <button class="btn-geo-locate" @click="geoLocate">
                            <span class="visually-hidden">Haal huidige locatie op</span>
                        </button>

                        <button
                            v-if="showResetButton"
                            @click="handleReset"
                            class="reset-map"
                        ><span class="visually-hidden">Reset map</span></button>

                        <Spinner v-if="loading"/>
                    </div>
                </div>
            </div>

            <div v-if="appointmentStore.hasGarages && !loading" class="garages-list">
                <GarageRow v-for="garage in appointmentStore.garages" :key="garage.id" :garage="garage" :request-offer="requestOffer"/>
            </div>
        </template>

        <div v-if="appointmentStore.hasInitialGarage" class="garages-list">
            <GarageRow :garage="appointmentStore.initialGarage" :request-offer="requestOffer" initial-garage/>
        </div>
    </div>
</template>